'use client'

import { useState } from 'react'
import ButtonAction from './ButtonAction'

const JudgesReveal = ({ judges }) => {
  const [isOpen, setIsOpen] = useState(false)

  if (!judges?.length) return null

  return (
    <div className="mt-6">
      {!isOpen ? (
        <ButtonAction
          handleChange={() => setIsOpen(true)}
          text="Informació Jutge Àrbitre"
          size="small"
        />
      ) : (
        <div className="flex flex-col gap-2">
          {judges.map((judge, jIdx) => (
            <div key={jIdx} className="relative pl-3 text-sm">
              <span className="absolute left-0 top-0.5 bottom-0.5 w-[2px] bg-sec-dark-blue" />
              <p>{judge.Name}</p>
              <p>{judge.Email}</p>
              <p>{judge.Phone}</p>
            </div>
          ))}
        </div>
      )}
    </div>
  )
}

export default JudgesReveal
